// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>5</span>&nbsp;&nbsp;But blessed be the Lord&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;who has not given us over to be a prey for their teeth.<br> </p> </div></div>";
// Exports
module.exports = code;